import script from "./sound-design-icon.vue?vue&type=script&setup=true&lang=js"
export * from "./sound-design-icon.vue?vue&type=script&setup=true&lang=js"

import "./sound-design-icon.vue?vue&type=style&index=0&id=0b4294c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b4294c2"]])

export default __exports__